import React, { useState, useContext } from "react";
// design
import { Form, Input, Button, Layout, Card, message } from "antd";
import "../assets/css/login.css";
import {
    BrowserRouter as Router,
    useHistory,
    useLocation,
} from "react-router-dom";
// context
import { GlobalContext } from "../context/globalContext";
// method
import { postMethod } from '../services/methods';
import setToken from '../utils/setting';

const { Content } = Layout;

const Login = (props) => {
    // context
    const { contextData, dispatch } = useContext(GlobalContext);

    // route
    let history = useHistory();
    let location = useLocation();
    let { from } = location.state || { from: { pathname: "/" } };

    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");

    const formSubmit = async () => {

        const loginData = await postMethod('/user/login', {
            phone: phone,
            password: password,
        });

        if (loginData) {
            if (loginData.token) {
                setToken(loginData.token);
                dispatch({ type: "CHANGE_USER_DATA", userData: loginData });
                localStorage.setItem("token", loginData.token);
                history.replace(from);
            } else {
                message.error("Giriş başarısız.");
            }
        }

    };

    return (
        <Content className="login-container">
            <Card className="card-login" title="Sisteme Girişi">
                <Form
                    size="large"
                    name="login"
                    layout="vertical"
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={() => formSubmit()}
                >
                    <Form.Item
                        label="Kullanıcı Adı"
                        name="phone"
                        onChange={(e) => setPhone(e.target.value)}
                        rules={[
                            {
                                required: true,
                                message: "Kullanıcı adınızı giriniz!",
                            },
                        ]}
                    >
                        <Input placeholder="Kullanıcı adı" />
                    </Form.Item>

                    <Form.Item
                        label="Şifre"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        rules={[
                            {
                                required: true,
                                message: "Şifrenizi giriniz!",
                            }
                        ]}
                    >
                        <Input.Password placeholder="Şifre" />
                    </Form.Item>

                    <Form.Item>
                        <Button block shape="round" type="primary" htmlType="submit">
                            Giriş Yap
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </Content>
    );
};

export default Login;
